(() => {
  const name = 'artist-static-video-preview';
  if (customElements.get(name)) return;
  const sizes = ['maxresdefault', 'sddefault', 'hqdefault', 'mqdefault', 'default'];
  customElements.define(name, class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.image = this.querySelector('[data-preview]');
      this.watch = this.querySelector('[data-watch]');
      this.onLoad = () => {
        if (this.image.naturalWidth <= 120) this.advance();
      };
      this.onError = () => this.advance();
      this.image.addEventListener('load', this.onLoad);
      this.image.addEventListener('error', this.onError);
      if (!this.image.hidden && this.image.complete) {
        if (this.image.naturalWidth) this.onLoad();
        else this.onError();
      }
      this.onKey = event => {
        if (event.key === ' ') {
          event.preventDefault();
          if (!event.repeat) this.watch.click();
        }
      };
      this.onClick = () => {
        this.pending = true;
      };
      this.onOtherVideoClick = event => {
        const target = event.target instanceof Element ? event.target.closest('a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[href*="vimeo.com/"], .product-video-trigger--mp4') : null;
        if (target && target !== this.watch) {
          this.pending = false;
          this.ownsModal = false;
          this.watch.setAttribute('aria-expanded', 'false');
          clearTimeout(this.returnTimer);
        }
      };
      this.onOpen = () => {
        clearTimeout(this.returnTimer);
        this.ownsModal = Boolean(this.pending || this.watch.getAttribute('aria-expanded') === 'true');
        this.pending = false;
        this.watch.setAttribute('aria-expanded', String(this.ownsModal));
      };
      this.onClose = () => {
        this.pending = false;
        if (!this.ownsModal) return;
        this.ownsModal = false;
        this.watch.setAttribute('aria-expanded', 'false');
        clearTimeout(this.returnTimer);
        this.returnTimer = setTimeout(() => {
          const modal = document.getElementById('VideoModal');
          if (this.isConnected && (!modal || !modal.classList.contains('modal--is-active'))) this.watch.focus();
        }, 550);
      };
      this.watch.addEventListener('keydown', this.onKey);
      this.watch.addEventListener('click', this.onClick, true);
      document.addEventListener('click', this.onOtherVideoClick, true);
      document.addEventListener('modalOpen.VideoModal', this.onOpen);
      document.addEventListener('modalClose.VideoModal', this.onClose);
    }
    advance() {
      const next = Number(this.image.dataset.previewIndex) + 1;
      if (next >= sizes.length) {
        this.image.hidden = true;
        return;
      }
      this.image.dataset.previewIndex = String(next);
      this.image.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(this.image.dataset.videoId) + '/' + sizes[next] + '.jpg';
    }
    disconnectedCallback() {
      this.bound = false;
      this.pending = false;
      this.ownsModal = false;
      clearTimeout(this.returnTimer);
      if (this.image) {
        this.image.removeEventListener('load', this.onLoad);
        this.image.removeEventListener('error', this.onError);
      }
      if (this.watch) {
        this.watch.setAttribute('aria-expanded', 'false');
        this.watch.removeEventListener('keydown', this.onKey);
        this.watch.removeEventListener('click', this.onClick, true);
      }
      document.removeEventListener('click', this.onOtherVideoClick, true);
      document.removeEventListener('modalOpen.VideoModal', this.onOpen);
      document.removeEventListener('modalClose.VideoModal', this.onClose);
    }
  });
})();
